"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var Play = function Play(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.33935 3.84576C6.24416 3.79405 6.13716 3.76797 6.02885 3.77008C5.92054 3.77219 5.81463 3.80241 5.72153 3.85779C5.62842 3.91317 5.5513 3.9918 5.49774 4.08596C5.44419 4.18013 5.41602 4.2866 5.41602 4.39493V15.6049C5.41602 15.7133 5.44419 15.8197 5.49774 15.9139C5.5513 16.0081 5.62842 16.0867 5.72153 16.1421C5.81463 16.1974 5.92054 16.2277 6.02885 16.2298C6.13716 16.2319 6.24416 16.2058 6.33935 16.1541L16.641 10.5491C16.7398 10.4954 16.8223 10.4161 16.8798 10.3194C16.9373 10.2227 16.9676 10.1124 16.9676 9.99993C16.9676 9.88747 16.9373 9.7771 16.8798 9.68045C16.8223 9.5838 16.7398 9.50445 16.641 9.45076L6.33935 3.84576ZM4.16602 4.39493C4.16602 2.97243 5.68768 2.06826 6.93685 2.74743L17.2385 8.35243C18.5435 9.06326 18.5435 10.9366 17.2385 11.6466L6.93685 17.2516C5.68768 17.9316 4.16602 17.0266 4.16602 15.6049V4.39493Z",
    fill: fill
  }));
};

var _default = Play;
exports["default"] = _default;